/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { Search, MyButton, Pagination } from "../../component/Component";
import { pushOneTradeOrganization } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useTradeOrganizationContext } from "../../../../context/tradeOrganization/TradeOrganizationContext";
import {
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiCalendar,
  FiInfo,
  FiTag,
  FiX,
  FiCheck,
} from "react-icons/fi";
import { AiFillBuild } from "react-icons/ai";

const addRoute = "/trade/org/add";
const editRoute = "/trade/org/edit";

const Overview = () => {
  const [tradeOrganizationList, setTradeOrganizationList] = useState([]);
  const { tradeOrganization, fetchTradeOrganizations, count } =
    useTradeOrganizationContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!tradeOrganization) fetchTradeOrganizations(page, pageSize);
    else setTradeOrganizationList(tradeOrganization);
  }, [tradeOrganization]);

  const SearchList = (e) => {
    const key = String(e.target.value).toLowerCase();
    if (!tradeOrganization) return;
    const filtered = tradeOrganization.filter((tOrg) =>
      String(tOrg?.name || "").toLowerCase().includes(key)
    );
    setTradeOrganizationList(key ? filtered : tradeOrganization);
  };

  const visibleCount = useMemo(
    () => (tradeOrganizationList?.length ? tradeOrganizationList.length : 0),
    [tradeOrganizationList]
  );

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4 lg:p-6">
      <div className="mx-auto max-w-6xl space-y-5">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <AiFillBuild className="h-5 w-5" />
              </span>
              <div>
                <div className="text-sm font-semibold tracking-tight text-gray-900">
                  Trade Organizations Manager
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                    <FiTag className="h-3.5 w-3.5" />
                    {visibleCount.toLocaleString()} results
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                    <FiInfo className="h-3.5 w-3.5" />
                    Add, edit, or remove organizations
                  </span>
                </div>
              </div>
            </div>

            <div className="flex w-full items-center gap-3 sm:w-auto">
              <div className="w-full sm:w-80">
                <Search
                  props={{
                    title: "Search organizations…",
                    onChange: (e) => SearchList(e),
                  }}
                />
              </div>
              <Link to={addRoute} className="shrink-0">
                <MyButton
                  className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-gray-900 to-gray-700 px-3 py-2 text-xs font-semibold text-white shadow hover:from-black hover:to-gray-800"
                  onClick={() => { }}
                >
                  <FiPlus className="h-4 w-4" />
                  Add Trade Organization
                </MyButton>
              </Link>
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[65vh] overflow-auto rounded-3xl">
            <table className="min-w-full table-fixed text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="w-[40%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <AiFillBuild className="h-4 w-4" />
                      Name
                    </span>
                  </th>
                  <th className="w-[30%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiCalendar className="h-4 w-4" />
                      Debuted On
                    </span>
                  </th>
                  <th className="px-4 py-3 text-center font-semibold">Action</th>
                </tr>
              </thead>

              <tbody>
                {tradeOrganizationList && tradeOrganizationList.length > 0 ? (
                  tradeOrganizationList.map((tOrg, key) => (
                    <tr
                      key={key}
                      className="border-t border-gray-100 hover:bg-gray-50/70"
                    >
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-[10px] font-bold text-white">
                            {String(tOrg?.name || "TO").slice(0, 2).toUpperCase()}
                          </span>
                          <div className="truncate font-semibold text-gray-900">
                            {tOrg?.name}
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <span className="inline-flex items-center gap-2 rounded-lg bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700 ring-1 ring-gray-200">
                          <FiCalendar className="h-3.5 w-3.5" />
                          {tOrg?.debuted_on || "—"}
                        </span>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center justify-center">
                          <ActionButton props={tOrg} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={3}>
                      No trade organizations found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="border-t border-gray-100 px-4 py-3">
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={count}
              callbackFunction={(p, s) => fetchTradeOrganizations(p, s)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props }) => {
  const {
    tradeOrganization,
    updateTradeOrganizationState,
    deleteTradeOrganization,
  } = useTradeOrganizationContext();

  const [open, setOpen] = useState(false);

  const trade_organization_id = props.trade_organization_id;
  const tradeOrganization_name = props.name;
  const tOrg = props;

  const remove = async () => {
    const { status } = await deleteTradeOrganization(trade_organization_id);
    if (status === 200) {
      if (tradeOrganization) {
        const update = tradeOrganization.filter(
          (x) => x.trade_organization_id !== trade_organization_id
        );
        updateTradeOrganizationState(update);
      }
      setOpen(false);
    }
  };

  return (
    <>
      <div className="inline-flex items-center gap-3">
        <Link to={editRoute}>
          <MyButton
            className="inline-flex items-center gap-2 rounded-lg bg-blue-700 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-blue-800"
            onClick={() => pushOneTradeOrganization(tOrg)}
          >
            <FiEdit2 className="h-4 w-4" />
            Edit
          </MyButton>
        </Link>

        <MyButton
          className="inline-flex items-center gap-2 rounded-lg bg-rose-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-rose-700"
          onClick={() => setOpen(true)}
        >
          <FiTrash2 className="h-4 w-4" />
          Delete
        </MyButton>
      </div>

      <ConfirmModal
        open={open}
        title="Delete this trade organization?"
        description={`“${tradeOrganization_name}” will be permanently removed.`}
        onCancel={() => setOpen(false)}
        onConfirm={remove}
        confirmText="Delete"
      />
    </>
  );
};

const ConfirmModal = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = "Proceed",
}) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-[2px]"
        onClick={onCancel}
      />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl" />
        <div className="relative px-5 pt-5">
          <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
            {title}
          </h3>
          {description ? (
            <p id="confirm-desc" className="mt-1 text-sm text-gray-600">
              {description}
            </p>
          ) : null}
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex items-center gap-2 rounded-lg bg-rose-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-rose-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
          >
            <FiCheck className="h-4 w-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Overview;
